import React from "react";
import Header from "./Header"; // Assuming this is your pre-built Header component
import Footer from "./Footer"; // Assuming this is your pre-built Footer component
import ImageSlider from "./ImageSlider";


const Contact = () => {
    
  const styles = {
    contactPage: {
      fontFamily: "'Roboto', Arial, sans-serif",
      backgroundColor: "#fafafa",
      color: "#333",
      padding: "0",
      margin: "0",
    },
    contactHero: {
      textAlign: "center",
      background: "linear-gradient(135deg, #ff6f91, #ff9671)",
      padding: "40px 20px",
      color: "white",
      borderBottom: "5px solid #ff9671",
    },
    title: {
      fontSize: "3rem",
      margin: 0,
      fontWeight: "bold",
    },
    subtitle: {
      fontSize: "1.25rem",
      marginTop: "10px",
    },
    contactContent: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "30px",
      padding: "40px 20px",
    },
    contactBox: {
      backgroundColor: "white",
      border: "1px solid #ff9671",
      borderRadius: "12px",
      padding: "25px",
      width: "320px",
      boxShadow: "0 6px 10px rgba(0, 0, 0, 0.15)",
      transition: "transform 0.2s, box-shadow 0.2s",
    },
    contactBoxHover: {
      transform: "translateY(-5px)",
      boxShadow: "0 8px 15px rgba(0, 0, 0, 0.2)",
    },
    contactHeading: {
      fontSize: "1.75rem",
      color: "#ff6f91",
      marginBottom: "15px",
      textAlign: "center",
    },
    contactDetails: {
      lineHeight: "1.6",
    },
    contactLink: {
      color: "#ff6f91",
      textDecoration: "none",
      fontWeight: "500",
    },
    contactLinkHover: {
      textDecoration: "underline",
    },
    footer: {
      marginTop: "30px",
    },
  };

  const contactSections = [
    
    {
        
      title: "General Inquiry",
      details: [
        { label: "Name", value: "Jamia Nida-E-Islam" },
         { label: "Phone Number", value: "+915324072008", href: "tel:+915324072008" },
        { label: "Email", value: "jninst786@gmail.com", href: "mailto:jninst786@gmail.com" },
        { label: "Timing", value: "9 AM to 3 PM" },
      ],
    },
    {
      title: "Donation Related",
      details: [
        { label: "Name", value: "Jamia Nida-E-Islam" },
          { label: "Phone Number", value: "+919005084268", href: "tel:+919005084268" },
        { label: "Email", value: "jninst786@gmail.com", href: "mailto:jninst786@gmail.com" },
        { label: "Timing", value: "9 AM to 3 PM" },
      ],
    },
  ];

  return (
    <div style={styles.contactPage}>
      <Header />
      
      <main>
        <section style={styles.contactHero}>
          <h1 style={styles.title}>Contact Us</h1>
          <p style={styles.subtitle}>
            We’re here to help. Reach out for any inquiries or support.
          </p>
        </section>

        <section style={styles.contactContent}>
          {contactSections.map((section, index) => (
            <div
              key={index}
              style={styles.contactBox}
              onMouseEnter={(e) =>
                Object.assign(e.currentTarget.style, styles.contactBoxHover)
              }
              onMouseLeave={(e) =>
                Object.assign(e.currentTarget.style, styles.contactBox)
              }
            >
              <h2 style={styles.contactHeading}>{section.title}</h2>
              <div style={styles.contactDetails}>
                {section.details.map((detail, idx) => (
                  <p key={idx}>
                    <strong>{detail.label}:</strong>{" "}
                    {detail.href ? (
                      <a
                        href={detail.href}
                        style={styles.contactLink}
                        onMouseEnter={(e) =>
                          Object.assign(e.target.style, styles.contactLinkHover)
                        }
                        onMouseLeave={(e) =>
                          Object.assign(e.target.style, styles.contactLink)
                        }
                      >
                        {detail.value}
                      </a>
                    ) : (
                      detail.value
                    )}
                  </p>
                ))}
              </div>
            </div>
          ))}
        </section>
      </main>
      
      <Footer style={styles.footer} />
    </div>
  );
};

export default Contact;
